import { render, staticRenderFns } from "./AlarmOutput.vue?vue&type=template&id=2ef16138&scoped=true&"
import script from "./AlarmOutput.vue?vue&type=script&lang=js&"
export * from "./AlarmOutput.vue?vue&type=script&lang=js&"
import style0 from "./AlarmOutput.vue?vue&type=style&index=0&id=2ef16138&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef16138",
  null
  
)

export default component.exports